export var valuesOrientation = ["horizontal", "vertical"];
//# sourceMappingURL=Orientation.js.map